module.exports = __webpack_public_path__ + "img/8.c1733f86.png";